import React, { useState } from 'react';

import classNames from 'classnames';

import { CurrencyIcon } from '@/blocks/components/AssetIcon';
import { BaseAutocomplete } from '@/blocks/components/Controls/Autocomplete';
import { AutocompleteOption } from '@/blocks/components/Controls/Autocomplete/Popper/AutocompleteOption';
import { TextField } from '@/blocks/components/Controls/TextField';
import { ChevronDown } from '@/blocks/components/Icons/Chevron';

import { ConverterCurrency } from '@/app/[lang]/converters/types';

// @ts-ignore
import { field } from '../styles.module.scss';
import styles from './styles.module.scss';

type AssetSearchProps = {
  inputLabel: React.ReactNode;
  onChange: (value: string) => void;
  value: string;
  currencies: ConverterCurrency[];
};

export function CurrencyConverterSelect({ inputLabel, value, onChange, currencies }: AssetSearchProps) {
  const selectedOption = currencies.find((currency) => currency.title === value) || null;
  const [open, setOpen] = useState(false);

  return (
    <BaseAutocomplete
      options={currencies}
      // disableClearable
      className={classNames(field)}
      value={selectedOption}
      selectOnFocus
      // autoHighlight
      onChange={(_, newValue) => onChange(newValue?.title || '')}
      filterOptions={(options, state) => {
        return options.filter((option) => {
          return (
            option.title?.toLowerCase().includes(state.inputValue.toLowerCase()) ||
            option.description?.toLowerCase().includes(state.inputValue.toLowerCase())
          );
        });
      }}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      getOptionLabel={(option) => option.title}
      renderOption={(props, option) => (
        <AutocompleteOption
          optionProps={{ ...props, key: option.title }}
          icon={<CurrencyIcon currencyName={option.title} width={18} height={18} />}
          title={option.title}
          key={option.title}
        />
      )}
      renderInput={(params) => (
        <TextField
          key={params.id}
          {...params}
          label={inputLabel}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <span className={classNames(open && styles.arrowOpen, styles.arrow)}>
                <ChevronDown />
              </span>
            ),
          }}
        />
      )}
    />
  );
}
